import { h } from 'preact'
import EventDateFormatter from './EventDateFormatter'
import { UserData } from './EventAttendees'
import EventAttendeesPreview from './EventAttendeesPreview'
import classNames from 'classnames'
import Icon from '../assets'
import globals from '../../utils/globals'

interface Event {
  id?: number,
  image?: string,
  startAt: number,
  endAt: number,
  title: string,
  destinationUrl: string,
  location?: string,
  type?: string,
  objectID?: string,
  attendees?: Array<UserData>,
  attendeeCount?: number,
  isLoggedInUserAttendee?: boolean,
}

interface EventPresentation extends Event {
  isFullWidth?: boolean,
  isFeatured?: boolean
}

interface Props {
  eventList: Array<Event>,
  className: string
}

const EventListView = ({ eventList, className }: Props) => {
  return (
    <div className={className}>
      {eventList.map(event => <EventListItemView {...event} />)}
    </div>
  )
}

export const EventListItemView = ({ id, title, type, startAt, endAt, image, location, destinationUrl, attendees, attendeeCount, isLoggedInUserAttendee, isFeatured, isFullWidth }: EventPresentation) => {
  const formattedStartAt = EventDateFormatter.formatStartAtForOverviewList(startAt)
  const isPastEvent = EventDateFormatter.isPastEvent(endAt)
  const isEventEngagementEnabled = ((globals('activeModules') || []).indexOf('eventEngagement') !== -1)
  return (
    <a href={destinationUrl} className={`event-list-item__url qa-event-list-item-url qa-event-${id}`}>
      <div className={classNames({
        'featured-event__item': image && isFeatured && !isFullWidth,
        'event-list-item-container': image,
        'event-list-item-details-full-width': !image
      })}>
        {image &&
        <div className='event-item-image-container'>
          {type &&
          <span class={`${isPastEvent ? 'event-pill__past' : ''} event-item__type pill pill--uppercase pill--article qa-content-type-pill`}>
            {type}
          </span>
          }
          <div className='event-item__image' style={{ backgroundImage: `url(${image})` }} />
        </div>
        }
        <div className='event-item-detail-container'>
          <div className={`${isPastEvent ? 'event__date_past' : ''} event-item__date`}>
            {formattedStartAt}
          </div>
          <div className='event-item__title'>
            {type && !image &&
            <span class={`${isPastEvent ? 'event-pill__past' : ''} event-detail-item__type pill pill--uppercase pill--article qa-content-type-pill`}>
              {type}
            </span>
            }
            <a href={destinationUrl} className='event-item__title qa-event-title'>
              {title}
            </a>
          </div>
          {location && <div className='event-item__location'>
            <div className='event-item__location_icon'><Icon icon='location' /> </div>
            <div>{location}</div>
          </div>}
          <EventAttendeesPreview isPastEvent={isPastEvent} attendeeCount={attendeeCount} attendees={attendees} isLoggedInUserAttendee={isLoggedInUserAttendee} isEventEngagementEnabled={isEventEngagementEnabled} />
        </div>
      </div>
    </a>
  )
}
export default EventListView
